import { useInjection } from '@cp/shared/di';
import { CATALOG_ITEM_VIEW_SERVICE } from '../di';

export const useCatalogItemViewService = () => useInjection(CATALOG_ITEM_VIEW_SERVICE);
